export const addAttributeEventListeners = (attr, callbackEvent) => {
  const events = document.querySelectorAll(`[${attr}]`);

  events.forEach((elem) => {
    if (elem) {
      const data = elem.getAttribute(`${attr}`);
      elem.onclick = (event) => callbackEvent(data, elem, event);
    }
  });
};

export const constructHourEvent = (date, hour, id) => {
  let initHour = hour.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

  let endHour = (hour + 1).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

  let finalEvent = {
    start: `${date} ${initHour}:00`,
    end: `${date} ${endHour}:00`,
    id: id,
    title: "",
  };

  return finalEvent;
};

export const getClickPosition = (elem, event) => {
  const rect = elem.getBoundingClientRect();
  const { top, height } = rect;

  const clickY = event.clientY - top;
  const hour = Math.floor((clickY * 24) / height);

  return hour;
};

export const getEventById = (id) => {
  const element = document.querySelector(`[data-event-id="${id}"]`);

  return element;
};

export const getEventPosition = (id) => {
  const element = getEventById(id);
  const rect = element.getBoundingClientRect();
  return rect;
};
